import React, { useRef } from "react"
import isNumeric from "validator/lib/isNumeric"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import { getUserList } from "services"
import { Select } from "components"
import { formatMobilePhone } from "utils"
import classes from "./RrhUserSelect.module.scss"

const RrhUserSelect = props => {
  const { filter, setFilter } = props

  const [t, i18n] = useTranslation()

  const timeout = useRef(null)

  const handleSelect = (select) => {
    setFilter(prev => ({
      ...prev,
      account: select
    }))
  }

  const handleSearch = (inputValue, callback) => {
    clearTimeout(timeout.current)

    timeout.current =
      setTimeout(async () => {
        const queries = { limit: 5 }

        if (isNumeric(inputValue)) {
          queries.mobilePhone =
            inputValue[0] === "0"
              ? inputValue.substring(1)
              : inputValue
        } else {
          queries.fullName = inputValue

          queries.username = inputValue
        }

        const { data: users } =
          await getUserList(queries)

        callback(users.map(user => ({
          label: `${user.fullName} ${user.mobilePhone ? `(${formatMobilePhone(user.mobilePhone)})` : ""}`,
          value: user._id
        })))
      }, 600)
  }

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <Select
      async
      isClearable
      label={t("جست_و_جوی_مشتری")}
      loadOptions={handleSearch}
      value={filter.account}
      noOptionsMessage={() => null}
      onChange={handleSelect}
      className={clsx(
        classes["input"],
        isLtr && classes["input-ltr"]
      )}
    />
  )
}

export default RrhUserSelect